/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

const advantagesAgreedSectionStyle = {
  centered: {
    textAlign: "center",
  },
  header: {
    color: "primary.main",
  },
};

export default advantagesAgreedSectionStyle;
